module.exports = __webpack_public_path__ + "static/media/NINT.afccd5be.svg";